import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailStatementIncomeComponent from './loansDetailStatementIncome.component';

let loansDetailStatementIncomeModule = angular.module('loansDetailStatementIncome', [
  uiRouter
])

.component('loansDetailStatementIncome', loansDetailStatementIncomeComponent)

.name;

export default loansDetailStatementIncomeModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailStatementIncome/loansDetailStatementIncome.js